(app => {

    app.filter("startFrom",
        function() {
            const startFrom = (arr, start) => {
                start = +start;

                return arr.slice(start);
            }

            return startFrom;
        });

})(window.app);